<template>
<div class="member_box clearfix">
  <div class="member_sidebar fl">
    <div class="member_count clearfix">
      <dl>
        <dd>
          <h3>{{score}}<i>分</i></h3>
          <p>我的学分</p>
        </dd>
        <dd>
          <h3>{{continuousDay}}<i>天</i></h3>
          <p>连续学习</p>
        </dd>
        <dd>
          <h3>{{totalHour}}<i>小时</i></h3>
          <p>累计学习</p>
        </dd>
        <dd>
          <h3>{{todayStudy}}<i>分钟</i></h3>
          <p>今日学习</p>
        </dd>
      </dl>
    </div>
    <div class="member_menu">
      <ul>
        <li v-for="item in navList" :class="{'active': item.isCur}">
          <a href="javascript:;" @click="navClick(item)">
            {{item.name}}
            <i></i>
          </a>
        </li>
        <!-- <li><a href="javascript:;"><i></i>我的学习</a></li>
        <li><a href="javascript:;"><i></i>我的账户</a></li>
        <li><a href="javascript:;"><i></i>我的工具</a></li>
        <li><a href="javascript:;"><i></i>个人设置</a></li> -->
      </ul>
    </div>
  </div>

  <div class="member_right fr">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
import '../../assets/css/member.css'
import {ApiGetUserInfo} from '../../net/accound/index.js'
export default {
  data: function () {
    return {
      score: 0, // 学分
      continuousDay: 0, // 连续学习(天数)
      totalHour: 0, // 累计学习   单位小时
      todayStudy: 0, // 今日学习时间(分钟)
      navList: [{
        name: '学习任务',
        path: '/Accound',
        isCur: true
      },{
        name: '直播课程',
        path: '/AccLive',
        isCur: false
      },{
        name: '试题练习',
        path: '/AccExam',
        isCur: false
      },{
        name: '我的学习',
        path: '/AccMyStudy',
        isCur: false
      },
      // {
      //   name: '我的账户',
      //   path: '/AccAccound',
      //   isCur: false
      // },
      {
        name: '我的工具',
        path: '/AccMyTool',
        isCur: false
      },{
        name: '个人设置',
        path: '/AccSetting',
        isCur: false
      }]
    }
  },
  methods:{
    getUserInfo: function () {
      ApiGetUserInfo().then(res=>{
        if (res.code == 200) {
          this.score = res.value.score
          this.continuousDay = res.value.continuousDay
          this.totalHour = res.value.totalHour
          this.todayStudy = res.value.todayStudy
        }
      })
    },
    navClick: function (item) {
      this.$router.push(item.path)
    },
    handlPath: function () {
      this.navList = this.navList.map(item=>{
        return {...item, isCur: item.path == this.$route.path}
      })
    }
  },
  watch: {
    '$route':'handlPath'
  },
  mounted: function () {
    this.getUserInfo()
    this.handlPath()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Accound/Accound.vue